import classNames from "classnames";
import type { FormFieldOption, HandleInputChange } from "./types";
import { useId } from "react";

type RadioInputProps = {
    name: string;
    options: Array<FormFieldOption | string>;
    value?: unknown;
    stacked?: boolean;
    disabled?: boolean;
    inputType?: "radio" | "checkbox";
    onChange: HandleInputChange;
    form?: string
};

const normalizeOption = (option: FormFieldOption | string): FormFieldOption => {
    if (typeof option === "string") {
        return { label: option, value: option };
    }
    return option;
};

const RadioInput = ({
    name,
    options,
    value,
    stacked = false,
    disabled = false,
    inputType = "radio",
    form,
    onChange,
}: RadioInputProps) => {
    const normalizedOptions = options.map(normalizeOption);
    

    return (
        <div>
            {normalizedOptions.map((opt) => {
                const uniqueId = Math.floor(Math.random()*99);//useId();
                const idValue = `${name}-${opt.value}`
                const optId = `${idValue}-${uniqueId}`;
                const optionValue = opt.value;

                return (
                    <div key={String(optId)} className={classNames("form-check", { "form-check-inline": !stacked })}>
                        <input
                            className="form-check-input"
                            id={optId}
                            type={inputType}
                            value={optionValue as string | number | readonly string[] | undefined}
                            checked={value === optionValue}
                            name={name}
                            disabled={!!disabled || !!opt.disabled}
                            form={form}
                            onChange={(event) => onChange(event, name, event.target.value)}
                        />
                        <label className="form-check-label" htmlFor={optId}>
                            {opt.label}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

export default RadioInput;
